<body>
  <div class="page-content newPadding getStartedBgpattern-5 px-0">
    <div class="container px-0 py-4">
      <div class="heading-title mb-4">
        <h3 class="font-weight-bold mb-2">Please select your card</h3>
        <!-- <p class="text-999999 font-weight-medium fs-17 pr-5">
          We've sent a one time verification message on
        </p> -->
      </div>
      <div class="cards-wrap">
        <div class="navbar-header mt-3"  *ngIf="manageCardDataList.CARD_TYPE == 'FINO' || 'EMI_CARD'">
        
        <div class="emi-card">
          <div class="emi-card-header mb-3">
            <div class="align-items-center">
              <div class="d-flex icon mr-2">
                    <img
                    src="./assets/img/emi-icon.svg"
                    alt="emi-card"
                    class="img-fluid"
                  />
                <div class="text">
                  <h5 class="font-weight-bold mb-0 pl-2">EMI Card</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="emi-card-body">
            <div class="container">
                <a routerLink="/managecard">
                    <img
                    src="./assets/images/EMI_CARD_project.png"
                    style="width: 100%"
                  />
                </a>
             
              <div>
                <div class="cardnumber">
                  {{emicardNum}}
                </div>
                <div class="validupto">{{ validUpto }}</div>
                <div class="cardname">{{ manageCardDataList.CUST_NAME }}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="navbar-header mt-3"  *ngIf="manageCardDataList.CARD_TYPE == 'FINO'">
        <div class="emi-card">
          <div class="emi-card-header mb-3">
            <div class="align-items-center">
              <div class="d-flex icon mr-2">
                <img
                  src="./assets/img/emi-icon.svg"
                  alt="fino-card"
                  class="img-fluid"
                />
                <div class="text">
                  <h5 class="font-weight-bold mb-0 pl-2">FINO Card</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="emi-card-body">
            <div class="container">
              <img
                src="./assets/img/img_fino.png"
                style="width: 100%"
                (click)="navigateFino()"
              />
              <div>
                <div class="cardnumber" id="fino-cardnumber">
                  {{ manageCardDataList.FINO_CARD_NO }}
                </div>
                <div class="validupto" id="fino-validupto">{{ validUptoFino }}</div>
                <div class="cardname" id="fino-cardname">{{ manageCardDataList.CUST_NAME }}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
      </div>
    </div>
  </div>
</body>
 <loader *ngIf="loader"></loader> 
